<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered hide-header hide-footer>
      <div class="modal-header">
        <h4 class="mb-0">ยืนยันตัวตนด้วยวิธีอื่น</h4>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div class="text-gray-2">
        ต้องการยืนยันตัวจนคุณ {{ selectedItem.name }} ด้วยวิธีอื่นหรือไม่
        (ทางแอดมินจะยืนยันอีกครั้ง)
      </div>
      <div class="mt-3">
        <b-button
          class="btn-modal radius-btn"
          block
          variant="secondary"
          :disabled="disabled"
          @click="conformWithoutOTP"
          >ยืนยัน</b-button
        >
        <b-button
          class="btn-modal radius-btn"
          block
          variant="outline"
          :disabled="disabled"
          @click="hide"
          >ยกเลิก</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showModal: false,
      disabled: false
    };
  },
  computed: {
    ...mapGetters({ selectedItem: "getSelectedItem" }),
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    async conformWithoutOTP() {
      let body = {
        new_status: 4,
        redeem_order_id: this.selectedItem.redeem_order_id,
      };
      await this.axios
        .post(`${this.$baseUrl}/redeem/update_redeem_order_status`, body)
        .then(async (data) => {
          if (data.result == 1) {
            this.disabled = true;
            this.successAlert();
            this.$router.push({ path: `/redeem/history/${this.selectedItem.member_id}` }).catch(() => {});
          } else {
            this.warningAlert(data.message);
          }
        })
        .catch((err) => {
          this.warningAlert(err.message);
        });
    },
    // 
  },
};
</script>

<style scoped>
.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

::v-deep .modal-body {
  color: var(--primary-color);
  padding: 15px !important;
}
.btn-outline {
  border-color: var(--primary-color) !important;
  background-color: transparent !important;
  color: var(--primary-color) !important;
}
</style>
